// extracted by mini-css-extract-plugin
export default {"tabsList":"TabsList_tabsList__HvGwj","tab":"TabsList_tab__-hygD"};